import {
    ADD_ADMIN_DASHBOARD_PROJECT,
    GET_ADMIN_DASHBOARD,
    REMOVE_ADMIN_DASHBOARD_PROJECT,
} from '../actions/types';
import {
    PostDispatch,
    IAdminDashboardData,
    ProjectBrowserModel,
} from '../types';

const INITIAL_STATE: IAdminDashboardData = {
    projects: [],
    researchAreas: [],
    pendingExternalSupervisorInvitations: [],
    failedPlagiarismChecks: [],
    intakes: [],
};

const reducer = (
    state = INITIAL_STATE,
    action: PostDispatch
): IAdminDashboardData => {
    switch (action.type) {
        case GET_ADMIN_DASHBOARD:
            return action.payload as IAdminDashboardData;
        case ADD_ADMIN_DASHBOARD_PROJECT: {
            const project = action.payload as ProjectBrowserModel;
            const projects = state.projects.some((p) => p._id === project._id)
                ? state.projects.map((p) =>
                      p._id === project._id ? project : p
                  )
                : [...state.projects, project];

            return { ...state, projects };
        }
        case REMOVE_ADMIN_DASHBOARD_PROJECT: {
            const { projectId } = action.payload as {
                projectId?: string | null;
            };

            if (!projectId) {
                return state;
            }

            return {
                ...state,
                projects: state.projects.filter((p) => p._id !== projectId),
            };
        }
        default:
            return state;
    }
};
export default reducer;
